var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8573 0H2.14288C0.964296 0 0 0.965409 0 2.16146V3.14136L1.42859 3.91236L9.66418 8.35796C9.87847 8.47327 10.1285 8.47327 10.3428 8.35796L18.5714 3.85472L20 3.06943V2.16158C20 0.965533 19.0429 0.000123444 17.8571 0.000123444L17.8573 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0214 9.66951C10.7 9.83815 10.35 9.92624 10.0001 9.92624C9.65729 9.92624 9.30714 9.83815 8.98571 9.66951L1.42857 5.51028L0 4.72531V13.7994C0 15.0097 0.964285 16 2.14286 16H17.8571C19.0429 16 20 15.0097 20 13.7994V4.66663L18.5714 5.45876L11.0212 9.66925L11.0214 9.66951Z",
    fill: "currentColor"
  })));
};
export default SvgMailIcon;